import Objects from "./Objects";

export default class CSVUtils {

  static convertArrayOfObjectsToCSV({data, columns, columnDelimiter = '","', lineDelimiter = '\n'}) {
    console.log('Fields', columns);

    var result, ctr, keys;

    if (Objects.isNullOrUndefined(data)) {
      return null;
    }

    // keys = Object.keys(fields);
    const header = [];
    columns.forEach(function (key) {
      header.push(key.Header);
    });

    result = '"';
    result += header.join(columnDelimiter) + '"';
    result += lineDelimiter;

    data.forEach(function (item) {
      columns.forEach(function (column) {
        result += '"' + (Objects.getValueByCustomField(column.accessor, item, column) || '') + '",';
      });
      result += lineDelimiter;
    });

    return result;
  }

}





// WEBPACK FOOTER //
// ./src/utils/CSVUtils.js